import * as React from "react";

function SvgButtonBoxFill(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 328 50"
      {...props}
    >
      <defs>
        <linearGradient
          id="button-box-fill_svg__a"
          x1=".536%"
          x2="100%"
          y1="50%"
          y2="50%"
        >
          <stop offset="0%" stopColor="#00B0E1" />
          <stop offset="100%" stopColor="#22CDDB" />
        </linearGradient>
      </defs>
      <rect
        width={328}
        height={50}
        rx={15}
        fill="url(#button-box-fill_svg__a)"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgButtonBoxFill;
